import { GET_COLLABORATIVES_REQUESTS } from '../actions/types';
const initState = {
	collaboratives_requests: [],
	collaboratives_invitation: [],
	requestor_data: [],
	emailUser: {},
	loading: false,
	collaboratives_request_invitations: [],
};

const collaborativeReducer = (state = initState, action) => {
	switch (action.type) {
		case GET_COLLABORATIVES_REQUESTS:
			return {
				...state,
				collaboratives_requests: action.payload,
			};
		case 'MY_COLLAB_REQUESTS':
			return {
				...state,
				requestor_data: [...state.requestor_data, action.payload],
			};
		case 'GET_COLLAB_INVITATIONS':
			return {
				...state,
				collaboratives_invitation: action.payload,
			};
		case 'GET_COLLAB_INVITATIONS_REQUEST':
			return {
				...state,
				collaboratives_request_invitations: action.payload,
			};
		case 'FETCH_BY_EMAIL':
			return {
				...state,
				emailUser: action.payload,
			};
		case 'COLLAB_LOADING':
			return {
				...state,
				loading: action.payload,
			};
		default:
			return state;
	}
};

export default collaborativeReducer;
